export default __webpack_public_path__ + "static/media/sm-destaque.6157f101.png";